import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { localStorageToken,authStorage } from "../utils/variables";

export const useStoreLocations = (storeId, storeLocationsOptions) => {
  return useQuery({
    queryKey: ["storeLocations", storeId, storeLocationsOptions],
    queryFn: async () => {
      const token = authStorage.getItem(localStorageToken);

      const { data } = await axios.get(
        `${process.env.REACT_APP_STORE_LOCATION_API}/stores/${storeId}/locations`,
        {
          params: storeLocationsOptions,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (data.code === 200) return data.data;
    },
    enabled: !!storeId,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
};

export const useStoreLocation = (storeId, storeLocationId) => {
  return useQuery({
    queryKey: ["storeLocation", storeId, storeLocationId],
    queryFn: async () => {
      const token = authStorage.getItem(localStorageToken);

      const { data } = await axios.get(
        `${process.env.REACT_APP_STORE_LOCATION_API}/stores/${storeId}/locations/${storeLocationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (data?.code === 200) return data.data?.storeLocationDetails;
    },
    enabled: !!storeId && !!storeLocationId,
  });
};

export const useStoreLocationMasterData = () => {
  return useQuery({
    queryKey: ["storeLocationMasterData"],
    queryFn: async () => {
      const token = authStorage.getItem(localStorageToken);

      const { data } = await axios.get(
        `${process.env.REACT_APP_STORE_LOCATION_API}/store-location-master`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (data?.code === 200) return data.data?.storeMasterData;
    },
    refetchOnWindowFocus: false,
  });
};
